import React from "react";
// import Ecomnavbar from "../../Components/Ecommerce/Navbar/Ecomnavbar";
import Footer from "../../components/Footer/Footer";
import "./contactus.scss";
import SellerNavbar from "../SellerNavbar";
const ContactUs = () => {
  return (
    <div className="ecomcontainer">
      {/* <Ecomnavbar /> */}
      <SellerNavbar/>




      <div className="contactusdiv">
        <h2 className="contactusheading">Contact Us</h2>
        <p className="contactustext">
          Feel free to reach out to us at Onstara Private Limited with any
          questions, feedback, or inquiries you may have. We're here to assist
          you in any way possible. Here are the ways you can get in touch with
          us:
        </p>

        <h2 className="contactusheading">Office Address</h2>
        <p className="contactustext">
        DOOR NO. AP 13/380G, SALAFI BUILDING,
KURUDIMUKKU, KARAYADU POST,
KOYILANDY, Kozhikode,
Kerala, India. 673524.
        </p>

        <h2 className="contactusheading">Email:</h2>
        <p className="contactustext">
          General Inquiries:{" "}
          <a
            href="mailto:info@onstara.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            info@onstara.com
          </a>
        </p>
        <p className="contactustext">
          Customer Support:{" "}
          <a
            href="mailto:support@onstara.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            support@onstara.com
          </a>
        </p>
        <p className="contactustext">
          Vendor Partnerships:{" "}
          <a
            href="mailto:vendors@onstara.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            vendors@onstara.com
          </a>
        </p>

        <h2 className="contactusheading">Phone Number</h2>
        <p className="contactustext">
          Main Office:{" "}
          <a href="tel:+919747287398" target="_blank" rel="noopener noreferrer">
            +91 9747287398
          </a>
        </p>

        <h2 className="contactusheading">WhatsApp Number:</h2>
        <p className="contactustext">
          Customer Support:{" "}
          <a
            href="https://wa.me/+919747287398"
            target="_blank"
            rel="noopener noreferrer"
          >
            +91 9747287398
          </a>
        </p>

        <p className="contactustext">
          Our dedicated team is available during our office hours to assist you
          promptly. We look forward to hearing from you and providing the
          assistance you need. Your satisfaction is our top priority at Onstara
          Private Limited.
        </p>
      </div>
      <div className="ecomfooterdiv">
        <Footer />
    
      </div>
    </div>
  );
};

export default ContactUs;
